export default __webpack_public_path__ + "static/media/nf.deaeae14.svg";